import type { ComputeBlockOptions, ComputeResourceCodes, ComputeResourceKind } from '../types';

/** 未由插件覆盖时的兜底 code（容器 / MaaS 等常见 legacy 值） */
export const DEFAULT_COMPUTE_RESOURCE_CODES: ComputeResourceCodes = {
  cpu: 'vCPU',
  memory: 'Memory',
  gpu: 'GPU',
  bandwidth: 'Bandwidth',
};

export function resolveComputeResourceCodes(options?: ComputeBlockOptions): ComputeResourceCodes {
  return {
    ...DEFAULT_COMPUTE_RESOURCE_CODES,
    ...options?.resourceCodes,
  };
}

export function resolveComputeResourceCode(kind: ComputeResourceKind, options?: ComputeBlockOptions): string {
  return resolveComputeResourceCodes(options)[kind];
}
